import React from "react";
import { Facebook, Instagram, Twitter, Mail, Phone, MapPin } from "lucide-react";

const Footer: React.FC = () => {
  return (
    <footer className="bg-slate-800 text-white pt-12 pb-8">
      <div className="container mx-auto px-4">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          <div>
            <h3 className="text-xl font-bold mb-4">Jog N Gym</h3>
            <p className="text-slate-300 mb-4">
              Your journey to a healthier you starts here. Quality fitness products for every level.
            </p>
            <div className="flex space-x-4">
              <a href="#" className="text-white hover:text-emerald-400 transition-colors">
                <Facebook size={20} />
              </a>
              <a href="#" className="text-white hover:text-emerald-400 transition-colors">
                <Instagram size={20} />
              </a>
              <a href="#" className="text-white hover:text-emerald-400 transition-colors">
                <Twitter size={20} />
              </a>
            </div>
          </div>
          
          <div>
            <h3 className="text-xl font-bold mb-4">Quick Links</h3>
            <ul className="space-y-2">
              <li>
                <a href="/" className="text-slate-300 hover:text-emerald-400 transition-colors">Home</a>
              </li>
              <li>
                <a href="/products" className="text-slate-300 hover:text-emerald-400 transition-colors">Products</a>
              </li>
              <li>
                <a href="/about" className="text-slate-300 hover:text-emerald-400 transition-colors">About Us</a>
              </li>
              <li>
                <a href="/contact" className="text-slate-300 hover:text-emerald-400 transition-colors">Contact</a>
              </li>
              <li>
                <a href="#" className="text-slate-300 hover:text-emerald-400 transition-colors">Privacy Policy</a>
              </li>
            </ul>
          </div>
          
          <div>
            <h3 className="text-xl font-bold mb-4">Contact Us</h3>
            <ul className="space-y-3">
              <li className="flex items-start space-x-3">
                <MapPin size={20} className="text-emerald-400 flex-shrink-0 mt-1" />
                <span className="text-slate-300">123 Fitness Street, Health City, HC 12345</span>
              </li>
              <li className="flex items-center space-x-3">
                <Phone size={20} className="text-emerald-400 flex-shrink-0" />
                <span className="text-slate-300">(123) 456-7890</span>
              </li>
              <li className="flex items-center space-x-3">
                <Mail size={20} className="text-emerald-400 flex-shrink-0" />
                <span className="text-slate-300">info@jogngym.com</span>
              </li>
            </ul>
          </div>
        </div>
        
        <div className="border-t border-slate-700 mt-8 pt-8 text-center text-slate-400">
          <p>&copy; {new Date().getFullYear()} Jog N Gym. All rights reserved.</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;